import { UPDATE_PROFIT_BY_STORE_WIDGET } from "./actionTypes";

const initialState = {
  data: {}  
};

const profitByStoreWidget = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROFIT_BY_STORE_WIDGET:
      const entity = action.payload;
      return { ...state, data: { ...state.data, [entity.id]: entity } };


    default:
      return state;
  }
};

export default profitByStoreWidget;